import { Drawer } from 'antd';
import React, { useState } from 'react';

import { TopNavbar } from '..';
import { InnerPageLayoutStyle1 } from './InnerPageLayout.style';
import SideBarV2 from '../SideBar/SideBarV2';
type InnerPageLayoutProps = {
  children: React.ReactElement | React.ReactElement[];
};

const InnerPageLayout = React.memo((props: InnerPageLayoutProps) => {
  const { children } = props;

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <InnerPageLayoutStyle1>
      <SideBarV2 className={'sidebarForPc'} />
      <div className="page-content" id="page-content">
        <TopNavbar showDrawer={showDrawer} onClose={onClose} />
        {children}
      </div>

      <Drawer className="mainSideBar" title={false} placement="left" onClose={onClose} open={open}>
        <SideBarV2 className={'sidebarForMob'} />
      </Drawer>
    </InnerPageLayoutStyle1>
  );
});

export default InnerPageLayout;
